/**
 * @file LeaderboardTable — renders a typed Leaderboard model. Highlights the
 * current player and surfaces a "mock data" note until the live feed is wired.
 */

import { formatRaceTime } from '../utils/format';

/** @param {{ leaderboard: import('../models/leaderboard').Leaderboard }} props */
export function LeaderboardTable({ leaderboard }) {
  const { entries, isLive, totalPlayers } = leaderboard;

  return (
    <section className="scrw-leaderboard">
      <div className="scrw-leaderboard__meta">
        <span>{totalPlayers.toLocaleString()} racers</span>
        {!isLive ? (
          <span className="scrw-badge scrw-badge--muted">Preview data</span>
        ) : (
          <span className="scrw-badge scrw-badge--live">Live</span>
        )}
      </div>
      <table className="scrw-table">
        <thead>
          <tr>
            <th scope="col" className="scrw-table__rank">#</th>
            <th scope="col">Racer</th>
            <th scope="col" className="scrw-table__time">Best time</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((e) => (
            <tr
              key={e.playerId}
              className={e.isCurrentPlayer ? 'scrw-table__row--me' : undefined}
            >
              <td className="scrw-table__rank">{e.rank}</td>
              <td>
                <span className="scrw-racer">{e.displayName}</span>
                {e.country ? (
                  <span className="scrw-racer__country"> · {e.country}</span>
                ) : null}
              </td>
              <td className="scrw-table__time">{formatRaceTime(e.timeMs)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
